import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=42fb17b9&scoped=true"
import script from "./curriculum.vue?vue&type=script&lang=js"
export * from "./curriculum.vue?vue&type=script&lang=js"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=42fb17b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb17b9",
  null
  
)

export default component.exports